import React, {useEffect, useState} from 'react';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useTheme, styled } from '@mui/material/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const InputComponent = styled('div')(({ theme }) => ({
    '& > *': {
        marginRight: theme.spacing(1)
    }
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiSelect-select': {
        padding: '16.5px 14px',
        minHeight: '24px',
    }
}));

const ChipMultipleSelect = ({label, id, data, value, setValue, disabled = false}) => {
    const theme = useTheme();

    const labelRef = React.useRef(null);
    const [labelWidth, setLabelWidth] = useState(0);

    useEffect(() => {
        setLabelWidth(labelRef.current.offsetWidth);
    }, []);

    const handleChange = event => {
        setValue(event.target.value);
    };

    const getStyles = (k) => {
        return {
            fontWeight:
                value.indexOf(k) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    };

    return (
        <FormControl fullWidth={true} disabled={disabled} variant="outlined">
            <InputLabel ref={labelRef} id={id + "-label"}>{label}</InputLabel>
            <StyledSelect
                labelId={id + "-label"}
                id={id}
                labelWidth={labelWidth}
                variant="outlined"
                multiple
                value={value}
                onChange={handleChange}
                renderValue={selected => (
                    <InputComponent>
                        {selected.map(value => data[value])}
                    </InputComponent>
                )}
                MenuProps={MenuProps}
            >
                {Object.keys(data).map(k => (
                    <MenuItem key={k} value={k} style={getStyles(k)}>
                        {data[k]}
                    </MenuItem>
                ))}
            </StyledSelect>
        </FormControl>
    );
};

export default ChipMultipleSelect;
